import { render, staticRenderFns } from "./FeedPage.vue?vue&type=template&id=4680a266&scoped=true"
import script from "./FeedPage.vue?vue&type=script&lang=js"
export * from "./FeedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680a266",
  null
  
)

export default component.exports